import React from "react";

import Labels from "../../../assets/labels";
import { Controller, useFormContext } from "react-hook-form";
import { Dropdown, Tooltip, useLang } from "@manulife/mux";
import NumberConstants from "../../../assets/appStyledComponents/numberConstant.json";

function RtgSynChildCount() {
  const { num200 } = NumberConstants;
  const selectedLang = useLang();
  const { control } = useFormContext(); // retrieve all hook methods
  const getLabelValue = () => {
    return (
      <>
        {`${Labels.childCount[`${selectedLang}`].label} `}
        <Tooltip
          content={Labels.childCount[selectedLang].tooltipText}
          aria-label={Labels.ariaChildCount[selectedLang]}
          bubbleWidth={num200}
        />
      </>
    );
  };
  return (
    <>
      <Controller
        control={control}
        name="rtgSynChildCount"
        rules={{
          required: Labels.errors.required[`${selectedLang}`],
        }}
        render={({
          field: { onChange, onBlur, value, name, ref },
          fieldState: { error },
        }) => (
          <Dropdown
            id={name}
            data-testId={name}
            dropdownItems={Labels.childCount[`${selectedLang}`].options}
            placeholder={Labels.select[`${selectedLang}`].label}
            label={getLabelValue()}
            aria-label={`${Labels.childCount[`${selectedLang}`].label} `}
            aria-labelledby={`${Labels.childCount[`${selectedLang}`].label} `}
            aria-required={true}
            customStyle={{
              rootStyle: {
                width: "100%",
              },
            }}
            ref={ref}
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            errors={error ? [error.message] : undefined}
            callouts={false}
          />
        )}
      />
    </>
  );
}

export default RtgSynChildCount;
